export const partNumber = 'The part number/name is used to uniquely identify your wave solder pallet. It is usually the same part number/name as your printed circuit board (PCB)';

export const revision = 'We recommend adding a revision number to each part number';

export const materialThickness = '6mm, 8mm or 12mm are the standard thicknesses';

export const stencilFile = 'Please include Gerber files and bill of material (BOM). If you have 3D file of the PCB, please include as well';

// These might be carrierWidth and carrierLength, confirm
export const carrierWidth = 'Width of the base plate';

export const carrierLength = 'Length of the base plate';

export const printConfirmation = 'Select “Yes” to request a check plot or proof of the artwork before manufacturing the pallet.';

export const holdDownQuantity = 'Hold Downs are used to hold the PCB securely in place. They are commonly made of titanium or plastic instead of steel to avoid cross contamination.';

export const needTopHat = 'Top Hat is also known as Cover Plate, is designed to hold shoulder bolts that push down the components in place during wave soldering and sits on top of the Base Plate. It typically features openings to reduce weight';

export const needStiffenerBar = 'Stiffener Bars are used to provide support to the pallet to reduce twisting and bending. They also prevent solder from going over the top area of the pallet';

export const shoulderBolts = 'Shoulder bolts have custom plungers designed to push down the TH components and keep them in place. They have springs to apply tension';
